// export const baseServerUrl = "http://10.0.2.183:9005"
export const baseServerUrl = "https://arp-brick.xkool.ai/api";
